import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import LeaderShip from '../LeaderShip/LeaderShip';
import Advisors from '../Advisors/Advisors';
import MarketingTeam from '../MarketingTeam/MarketingTeam';
import SalesTeam from '../SalesTeam/SalesTeam';
import OtherMembers from '../OtherMembers/OtherMembers';

export default function About() {
  const mainHeadingStyle = {
    color: "white",
    fontWeight: "300",
    lineHeight: "1.2rem",
    fontSize: "31px",
  };
  return (
    <Box>
      <Box bg={"linear-gradient(300deg, #1899C7 36%, #1F508B 100%)"} textAlign="center" padding={"60px 0px"}>
        <Text {...mainHeadingStyle}>About Our Team &</Text>
        <Text {...mainHeadingStyle} mt={"18px"}>Asset Tokenization CRE</Text>
      </Box>
      <Box padding={"80px 0px 0px 0px"}>
        <LeaderShip />
        <Advisors />
        <MarketingTeam />
        <SalesTeam />
        <OtherMembers />
      </Box>
    </Box>
  );
}